import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "file-select uk-align-left" }
const _hoisted_2 = { class: "uk-margin-bottom" }
const _hoisted_3 = {
  key: 0,
  "uk-icon": "icon: upload",
  "uk-tooltip": "uploadText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.iconOnly)
        ? (_openBlock(), _createElementBlock("a", _hoisted_3))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isLargeText)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  "uk-icon": "icon: upload; ratio: 1.4",
                  class: _normalizeClass(["uk-button uk-text-large", _ctx.classes()])
                }, _toDisplayString(_ctx.uploadText), 3))
              : _createCommentVNode("", true),
            (_ctx.isMediumText)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  "uk-icon": "icon: upload; ratio: 1.4",
                  class: _normalizeClass(["uk-button uk-text-medium", _ctx.classes()])
                }, _toDisplayString(_ctx.uploadText), 3))
              : (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  "uk-icon": "icon: upload",
                  class: _normalizeClass(["uk-button", _ctx.classes()])
                }, _toDisplayString(_ctx.uploadText), 3))
          ], 64))
    ]),
    _createElementVNode("input", {
      type: "file",
      accept: ".pdf",
      onChange: _cache[0] || (_cache[0] = event => this.$emit('file-uploaded', event))
    }, null, 32)
  ]))
}